module.exports = __webpack_public_path__ + "static/media/key-wheelchair-icon.c8d65689.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/key-wheelchair-icon.svg
// module id = 885
// module chunks = 0